import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';

import {PopUpElement} from "../models/PopUpModel";

import { environment } from '../../environments/environment';

  ///import { environment } from '../../../environments/environment';
//   private apiUrl = environment.apiUrl;

@Injectable()
export class PopUpService {

    ///import { environment } from '../../../environments/environment';
    private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }



  /////////////////////////////  ------------- CURD -----------------

  addPopUpData(objj:PopUpElement) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  return this.http.post(""+this.apiUrl+"/PopUp/AddPopUp",
  JSON.stringify(objj),
   httpOptions
  )
  }

  /////////////////////////////  ------------- CURD -----------------



  ///////////////////////  ----------- GET ALL BY ID -----------

  getAllPopUpByIdData(para:string) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/PopUp/GetAllPopUpById?Para="+para,httpOptions);
  }

   ///////////////////////  ----------- GET ALL BY ID -----------


  getAllMidPopIdMAPPINGData( mid:number , stat : number,  para:string ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/PopUp/GetAllMidPopIdMAPPING?AdmissionMasterId="+mid+"&Stat="+stat+"&Parameter="+para,httpOptions);
  }
  
  saveMidPopIdMAPPINGUpdateData(data) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.post<any>(""+this.apiUrl+"/PopUp/UploadComponentPermissionMidPopId",data, {
      reportProgress: true,
      observe: 'events'
    });
  }
 
  getallNotificationonDashboardData( cb:number , stat : string,  fd:string, td:string  ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
   
  return this.http.get(""+this.apiUrl+"/PopUp/PrintNotificationonDashboard?CreatedBy="+cb+"&Status="+stat+"&FromDate="+fd+"&ToDate="+td,httpOptions);

  }


  ////////////////////////////  ACCESS RULES //////////////////////////
  
  addAccessData(objj:PopUpElement) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  return this.http.post(""+this.apiUrl+"/PopUp/AddAccess",
  JSON.stringify(objj),
   httpOptions
  )
  }

  getAllAccessMAPPINGData( arn:string,  arf:string, ipr:number  ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };

    // return this.http.get("http://localhost:49587/api/PopUp/GetAllAccessMAPPING?AccessRuleNaming="+arn+"&AccessRuleFor="+arf+"&IsPermitted="+ipr,httpOptions);
  
       return this.http.get(""+this.apiUrl+"/PopUp/GetAllAccessMAPPING?AccessRuleNaming="+arn+"&AccessRuleFor="+arf+"&IsPermitted="+ipr,httpOptions);
  
  }
  
  uploadComponentPermissionAccessData(data) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
     // return this.http.post<any>("http://localhost:49587/api/PopUp/UploadComponentPermissionAccess",data, {
  
      return this.http.post<any>(""+this.apiUrl+"/PopUp/UploadComponentPermissionAccess",data, {
      reportProgress: true,
      observe: 'events'
      });
  }

  //////////////////////////////// ACCESS RULES //////////////////////



}
